import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbfa36a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "adt-mtrl"
}

import { ref, computed } from 'vue'
import { t } from '@/plugins/i18n'
import TableLike from '@/components/common/TableLike.vue'
import { getIngredients } from '@/apis/addition'
import { useRtfix } from '@/store'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { COUNTRY } from '@/global'
import { useStore } from 'vuex'
import { jpWareInfo } from '@/common/const'

export default /*#__PURE__*/_defineComponent({
  props: ['adtMap', 'sort', 'countryCode'],
  setup(__props) {

const props = __props
const store = useStore()

const scrollbar = ref()
const data = computed(() => {
  const newData = Object.values(props.sort ?? props.adtMap).filter((v: any) => v.ingredientStatus)
  if (newData.length > data.value?.length) {
    scrollbar.value && scrollbar.value.setScrollTop(0)
  }
  return Object.values(props.sort ?? props.adtMap).filter((v: any) => v.ingredientStatus)
})
console.log(data)

const columns = [
  { prop: 'additionNameJp', label: '附加项' },
  { prop: 'mtlname', label: '辅料名', slotName: 'mtlname' },
  { prop: 'ingredientsSku', label: '辅料sku' },
  { prop: 'storenum', label: '预计在库数', width: '100', slotName: 'storenum' },
  { prop: 'action', label: '操作', width: '200', slotName: 'action' }
].fort()

const ingt: any = ref([])
if (store.getters.isLogin) {
  getIngredients({ wareHouseLocation: props.countryCode }).then((res) => {
    ingt.value = res.data ?? []
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(data).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)('辅料选择')), 1))
      : _createCommentVNode("", true),
    (_unref(data).length)
      ? (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 1,
          height: "188px",
          style: {"width":"calc(100% + 14px)"},
          always: "",
          ref: (_value, _refs) => {
            _refs['scrollbar'] = _value
            scrollbar.value = _value
          }
        }, {
          default: _withCtx(() => [
            _createVNode(TableLike, {
              data: _unref(data),
              columns: _unref(columns),
              headClass: "mtrl-table",
              style: {"padding-right":"14px"}
            }, {
              mtlname: _withCtx(({ item }) => [
                _createVNode(_component_el_select, {
                  modelValue: item.ingredientsSku,
                  "onUpdate:modelValue": ($event: any) => ((item.ingredientsSku) = $event),
                  placeholder: _unref(t)('请选择2'),
                  "popper-class": "select-sku"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ingt.value, (v) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: v.ingredientsSku,
                        label: v.ingredientsNameJp,
                        value: v.ingredientsSku
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
              ]),
              storenum: _withCtx(({ item }) => [
                _createTextVNode(_toDisplayString(ingt.value?.find((v) => v.ingredientsSku === item.ingredientsSku)?.useable ?? '-') + " " + _toDisplayString(_unref(t)('件')), 1)
              ]),
              action: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: _unref(useRtfix)('stock', { query: { stock: 'materials' } }),
                  tag: "a",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_table_button, {
                      title: _unref(t)('去补货')
                    }, null, 8, ["title"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _: 1
            }, 8, ["data", "columns"])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ], 64))
}
}

})